import { type ReactNode } from 'react';
import { ConfirmButtons } from './creator-delete-confirm';
import { TemplateChips } from '@/components/ui/template-chips';
import { COLLECTOR_APPEAL_TEMPLATES } from '../data/appeal-templates';
import {
  APPEAL_MAX_CHARS,
  APPEAL_MIN_CHARS,
  type useAppealForm,
} from '../hooks/use-appeal-form';

export function AppealHelp(): ReactNode {
  return (
    <p className="text-xs text-text-secondary">
      Cuéntale al equipo por qué este lead es válido a pesar de lo que dijo la
      IA. Sé concreto (mínimo {APPEAL_MIN_CHARS} caracteres). Un admin la
      revisará.
    </p>
  );
}

export function AppealTextarea(p: {
  value: string;
  bad: boolean;
  onChange: (v: string) => void;
}): ReactNode {
  const border = p.bad
    ? 'border-error focus:border-error'
    : 'border-white/[0.06] focus:border-brand-red';
  return (
    <textarea
      value={p.value}
      onChange={(e) => p.onChange(e.target.value.slice(0, APPEAL_MAX_CHARS))}
      placeholder={`Explica por qué este lead encaja en Debook (mínimo ${APPEAL_MIN_CHARS} caracteres)`}
      rows={4}
      aria-invalid={p.bad || undefined}
      className={`w-full rounded-md border bg-surface-elevated p-sm text-xs text-text-primary placeholder:text-text-tertiary focus:outline-none ${border}`}
    />
  );
}

export function AppealFooter(p: {
  length: number;
  bad: boolean;
  disabled: boolean;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}): ReactNode {
  const counterCls = p.bad ? 'text-error' : 'text-text-secondary';
  return (
    <div className="flex items-center justify-between gap-sm">
      <span className={`text-xs ${counterCls}`}>
        {p.length}/{APPEAL_MAX_CHARS} · mínimo {APPEAL_MIN_CHARS}
      </span>
      <ConfirmButtons
        onCancel={p.onCancel}
        onConfirm={p.onConfirm}
        isPending={p.isPending || p.disabled}
        label="Enviar apelación"
        variant="primary"
      />
    </div>
  );
}

export function AppealChips(p: {
  current: string;
  onPick: (t: string) => void;
}): ReactNode {
  return (
    <TemplateChips
      templates={COLLECTOR_APPEAL_TEMPLATES}
      current={p.current}
      onPick={p.onPick}
    />
  );
}

export type AppealFormHook = ReturnType<typeof useAppealForm>;
